import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import createApolloClient from './create-client';
import blazeClientHeaderMiddleware from './blaze-client-header-middleware';
import getTypeChacheSettingsHelper from './get-type-cache-settings-helper';
const QUERY_KEY = 'Query';
const MUTATION_KEY = 'Mutation';
function apolloHandler({
  apollo: clientConfig = {}
} = {}) {
  const resolvers = {
    [QUERY_KEY]: {},
    [MUTATION_KEY]: {}
  };
  const providerProps = {};
  const middleware = [];
  const {
    loadEntities,
    getTypeCacheSettings,
    getProcessedEntities
  } = getTypeChacheSettingsHelper(clientConfig);
  let client = null;
  function getQueryResolver(key) {
    return resolvers[QUERY_KEY][key];
  }
  function getMutationResolver(key) {
    return resolvers[MUTATION_KEY][key];
  }
  function getResolvers() {
    return _objectSpread({}, resolvers);
  }
  function addResolver(key, resolver, type) {
    validateResolver(key, resolver, type);
    resolvers[type][key] = resolver;
  }
  function addQueryResolver(key, resolver) {
    addResolver(key, resolver, QUERY_KEY);
  }
  function addMutationResolver(key, resolver) {
    addResolver(key, resolver, MUTATION_KEY);
  }
  function validateResolver(key, resolver, type) {
    if (!key) throw new Error('Resolver requires a key');
    if (typeof resolver !== 'function') throw new Error(`Resolver (${type}: ${key}) needs to be a function`);
    if (resolvers[type][key]) throw new Error(`Resolver with ${type}: ${key} has been already added`);
  }
  function createClient(initialState, processedEntities) {
    client = createApolloClient(_objectSpread(_objectSpread({}, clientConfig), {}, {
      resolvers,
      middleware,
      initialState
    }, getTypeCacheSettings(processedEntities)));
    return client;
  }
  function getClient() {
    return client;
  }
  function getProviderProps() {
    return _objectSpread({}, providerProps);
  }
  function addProviderProps(props) {
    _extends(providerProps, props);
  }
  function addMiddleware(customMiddleware) {
    if (!customMiddleware || typeof customMiddleware !== 'function' && typeof customMiddleware !== 'object') {
      throw new Error('Middleware needs to be a function or Object');
    }
    middleware.push(customMiddleware);
  }
  function getAllMiddleware() {
    return [...middleware];
  }
  if (process.env.BLAZE_CLIENT_HEADER) addMiddleware(blazeClientHeaderMiddleware);
  return {
    getQueryResolver,
    getMutationResolver,
    getResolvers,
    addQueryResolver,
    addMutationResolver,
    getProviderProps,
    addProviderProps,
    createClient,
    getClient,
    addMiddleware,
    getAllMiddleware,
    loadEntities,
    getProcessedEntities
  };
}
export default apolloHandler;
//# sourceMappingURL=handler.js.map